<template>
  <div v-loading="isLoading">
    <div v-if="courseServiceItemList.length > 0" class="serviceItemList-container">
      <el-row class="serviceItemList-title">
        <el-col v-for="(colOption, index) in columnOptions.course" :key="index" :span="colOption.span">{{ !!colOption.title ? colOption.title : "&nbsp;" }}
        </el-col>
      </el-row>
      <courseServiceItemDetail v-for="serviceItem in courseServiceItemList" :key="serviceItem.Id" :columnOptions="columnOptions.course" :currency="currency"
        :readonly="readonly" :data="serviceItem" @editEndDate="onEditEndDate" @addCourse="onAddCourse" @close="onServiceItemDetailClose" @edit="onCourseEdit"
        @refund="onCourseRefund" />
    </div>
    <div v-if="nonCourseServiceItemList.length > 0" class="serviceItemList-container">
      <el-row class="serviceItemList-title">
        <el-col v-for="(colOption, index) in columnOptions.nonCourse" :key="index" :span="colOption.span">{{ !!colOption.title ? colOption.title : "&nbsp;" }}
        </el-col>
      </el-row>
      <nonCourseServiceItemDetail v-for="serviceItem in nonCourseServiceItemList" :key="serviceItem.Id" :columnOptions="columnOptions.nonCourse"
        :currency="currency" :readonly="readonly" :data="serviceItem" @close="onServiceItemDetailClose" @addRecord="showNCServiceRecordEditorAdd"
        @editRecord="showNCServiceRecordEditorEdit" />
    </div>
    <serviceItemEndDateEditor :visible="serviceItemEndDateEditorOptions.visible" :data="serviceItemEndDateEditorOptions.dataIn"
      @close="hideServiceItemEndDateEditor" @change="onServiceItemEndDateEditorChange" />
    <ncServiceRecordEditor :visible="nonCourseServiceRecordEditorOptions.visible" :data="nonCourseServiceRecordEditorOptions.dataIn"
      :isTimeQuantity="nonCourseServiceRecordEditorOptions.isTimeQuantity" :serviceHoursAvailable="
        nonCourseServiceRecordEditorOptions.serviceHoursAvailable
      " @close="hideNCServiceRecordEditor" @change="onNCServiceRecordEditorChange" />
    <el-dialog center title="添加课程" :close-on-click-modal="false" width="820px" :visible.sync="selectCourseDialogVisible" top="8vh">
      <selectCourseDialog :dataIn="selectCourseData" :isStudyAbroad="true" :courseType="1" @saveSuccess="onSelectCourseSaveSuccess">
      </selectCourseDialog>
    </el-dialog>
    <courseEditor :visible="courseEditorVisible" :dataIn="courseEditorData" @saveSuccess="onCourseEditorSaveSuccess" @close="onCourseEditorClose" />
    <courseRefund :visible="courseRefundVisible" :dataIn="courseRefundData" @saveSuccess="onCourseRefundSaveSuccess" @close="onCourseRefundClose" />
  </div>
</template>

<script>
import global_ from "@/core/global";

import {
  changeSAWorkflowServiceItemStartDate,
  closeSAWorkflowServiceItemById,
  saveSANonCourseServiceRecord,
  saveStudyAbroadCourses,
} from "@/service/studyAbroad.service";

const defaultColumnOptions = {
  nonCourse: [
    {
      span: 5,
      title: "项目名称",
    },
    {
      span: 4,
      title: "截止日期",
    },
    {
      span: 3,
      title: "剩余",
    },
    {
      span: 4,
      title: "项目剩余额度",
    },
    {
      span: 3,
      title: "状态",
    },
    {
      span: 5,
      align: "right",
    },
  ],
  course: [
    {
      span: 5,
      title: "项目名称",
    },
    {
      span: 4,
      title: "截止日期",
    },
    {
      span: 3,
      title: "剩余",
    },
    {
      span: 4,
      title: "项目剩余额度",
    },
    {
      span: 3,
      title: "状态",
    },
    {
      span: 5,
      align: "right",
    },
  ],
};

const defaultNCServiceRecord = {
  Id: 0,
  CreateDate: new Date(),
  WorkflowServiceItemId: 0,
  ServiceDate: null,
  QuantityDeduction: 1,
  ServiceProvider: null,
  Comment: null,
  Currency: 0,
  CostAmountDeduction: 0,
  SaleAmountDeduction: 0,
  RecordType: 0,
};

export default {
  name: "serviceItemList",
  components: {
    nonCourseServiceItemDetail: () => import("./nonCourseServiceItemDetail"),
    courseServiceItemDetail: () => import("./courseServiceItemDetail"),
    serviceItemEndDateEditor: () => import("./serviceItemEndDateEditor"),
    ncServiceRecordEditor: () => import("./nonCourseServiceRecordEditor"),
    selectCourseDialog: () =>
      import(
        "@/components/addCollectFees/courseEnrollmentFee/selectCourseDialog"
      ),
    courseEditor: () => import("../courseEditor"),
    courseRefund: () => import("../courseRefund"),
  },
  props: {
    studentInfo: Object,
    currency: {
      type: Number,
      default: global_.currencyType.CNY,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      columnOptions: {
        course: Object.clone(defaultColumnOptions.course),
        nonCourse: Object.clone(defaultColumnOptions.nonCourse),
      },
      serviceItemEndDateEditorOptions: {
        visible: false,
        dataIn: null,
      },
      nonCourseServiceRecordEditorOptions: {
        serviceItem: null,
        visible: false,
        dataIn: Object.clone(defaultNCServiceRecord),
        isTimeQuantity: false,
        serviceHoursAvailable: 0,
      },
      courseEditorVisible: false,
      courseEditorData: {
        isVIP: false,
        hours: 0,
        maxHours: 0,
        serviceItemName: "",
        termId: 0,
        termName: "",
        courseId: 0,
        courseName: "",
        workflowServiceItemId: 0,
        workflowCourseId: 0,
        universityGroup: 0,
      },
      courseRefundVisible: false,
      courseRefundData: {
        serviceItemName: "",
        termId: 0,
        termName: "",
        courseId: 0,
        courseName: "",
        workflowServiceItemId: 0,
        workflowCourseId: 0,
        universityGroup: 0,
      },
      selectCourseDialogVisible: false,
      selectCourseData: {
        studyAbroadData: {
          workflowServiceItemId: 0,
          endDate: "",
          serviceItemName: "",
          quantityTotal: 0,
          quantityAvailable: 0,
        },
        universityCourseData: {
          universityGroupNumber: 0,
          universityGroupText: "",
          termId: 0,
          selectedCourseIdList: [],
        },
      },
    };
  },
  computed: {
    nonCourseServiceItemList() {
      return this.data.filter(
        (item) => item.ServiceType === this.GLOBAL.enumSAServiceType.NonCourse 
          || item.ServiceType === this.GLOBAL.enumSAServiceType.AutoAttrition 
      );
    },
    courseServiceItemList() {
      return this.data.filter(
        (item) => item.ServiceType === this.GLOBAL.enumSAServiceType.Course
      );
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async changeSAWorkflowServiceItemStartDateToServer(serviceItem) {
      let result = await changeSAWorkflowServiceItemStartDate(
        serviceItem.Id,
        serviceItem.StartDate
      );
      if (!result || !result.success) {
        this.$message.error(result.message);
        return false;
      }

      this.$message({
        message: "修改截止日期成功",
        type: "success",
      });

      if (!!this.serviceItemEndDateEditorOptions.dataIn) {
        this.serviceItemEndDateEditorOptions.dataIn.StartDate =
          serviceItem.StartDate;
      }

      this.$emit("change");

      return true;
    },
    async closeSAWorkflowServiceItemByIdToServer(serviceItem, closeDate) {
      this.isLoading = true;
      let result = await closeSAWorkflowServiceItemById(
        serviceItem.Id,
        closeDate
      );
      if (!result || !result.success) {
        this.$message.error(result.message);
        return false;
      }

      this.$message({
        message: "结束小项成功",
        type: "success",
      });
      this.isLoading = false;
      this.$emit("change", true);

      return true;
    },
    async saveSANonCourseServiceRecordToServer(serviceRecord, serviceItem) {
      let result = await saveSANonCourseServiceRecord(serviceRecord);
      if (!result || !result.success) {
        this.$message.error(result.message);
        return false;
      }

      this.$message({
        message: "服务记录保存成功",
        type: "success",
      });

      if (serviceRecord.Id === 0) {
        serviceRecord.Id = result.data;
        serviceItem.NonCourseServiceRecordList.push(serviceRecord);
        if (serviceItem.QuantityTotal !== -1)
          serviceItem.QuantityAvailable -= serviceRecord.QuantityDeduction;
        serviceItem.CostAmountAvailable =
          (serviceItem.CostAmountDiscounted / serviceItem.QuantityTotal) *
          serviceItem.QuantityAvailable;
        serviceItem.SaleAmountAvailable =
          (serviceItem.SaleAmountDiscounted / serviceItem.QuantityTotal) *
          serviceItem.QuantityAvailable;
        if (serviceItem.QuantityTotal !== -1 && !serviceItem.QuantityAvailable)
          serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.Completed;
        else if (serviceItem.QuantityAvailable != serviceItem.QuantityTotal)
          serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.InProgress;
        else serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.NotStart;
      } else {
        let oldServiceRecord = serviceItem.NonCourseServiceRecordList.find(
          (item) => item.Id === serviceRecord.Id
        );
        if (!!oldServiceRecord) {
          let quantityDiff =
            serviceRecord.QuantityDeduction -
            oldServiceRecord.QuantityDeduction;
          Object.copy(oldServiceRecord, serviceRecord);
          if (quantityDiff !== 0) {
            if (serviceItem.QuantityTotal !== -1)
              serviceItem.QuantityAvailable -= quantityDiff;
            serviceItem.CostAmountAvailable =
              (serviceItem.CostAmountDiscounted / serviceItem.QuantityTotal) *
              serviceItem.QuantityAvailable;
            serviceItem.SaleAmountAvailable =
              (serviceItem.SaleAmountDiscounted / serviceItem.QuantityTotal) *
              serviceItem.QuantityAvailable;
            if (
              serviceItem.QuantityTotal !== -1 &&
              !serviceItem.QuantityAvailable
            )
              serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.Completed;
            else if (serviceItem.QuantityAvailable != serviceItem.QuantityTotal)
              serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.InProgress;
            else
              serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.NotStart;
          }
        }
      }

      this.$emit("change");

      return true;
    },

    onServiceItemDetailClose(serviceItem) {
      let closeDate = this.$moment().toDate();
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        message: h("div", null, [
          h(
            "div",
            null,
            `您确定要关闭该小项${
              !!serviceItem.ServiceItemName
                ? " - " + serviceItem.ServiceItemName
                : String.empty
            }吗?`
          ),
          h("div", null, [
            h("span", null, "关闭日期："),
            h("msg-date-picker", {
              props: {
                size: "small",
                format: "yyyy/MM/dd",
                placeholder: "请选择关闭日期",
                value: closeDate,
              },
              on: {
                change(newValue) {
                  closeDate = newValue;
                },
              },
            }),
          ]),
        ]),
      })
        .then(() => {
          closeDate = closeDate || this.$moment().toDate();
          closeDate = this.$moment(closeDate).format("YYYY/MM/DD");
          this.closeSAWorkflowServiceItemByIdToServer(serviceItem, closeDate);
        })
        .catch(() => {});
    },
    showNCServiceRecordEditorAdd(serviceItem) {
      this.nonCourseServiceRecordEditorOptions.serviceItem = serviceItem;

      let dataIn = Object.clone(defaultNCServiceRecord);
      dataIn.WorkflowServiceItemId = serviceItem.Id;
      this.nonCourseServiceRecordEditorOptions.dataIn = dataIn;

      this.nonCourseServiceRecordEditorOptions.isTimeQuantity =
        serviceItem.TimeLimitEnable;
      this.nonCourseServiceRecordEditorOptions.serviceHoursAvailable =
        serviceItem.QuantityTotal != -1
          ? serviceItem.QuantityAvailable
          : Number.maxValue.int32;

      this.nonCourseServiceRecordEditorOptions.visible = true;
    },
    showNCServiceRecordEditorEdit(record, serviceItem) {
      this.nonCourseServiceRecordEditorOptions.serviceItem = serviceItem;

      let dataIn = record;
      this.nonCourseServiceRecordEditorOptions.dataIn = dataIn;

      this.nonCourseServiceRecordEditorOptions.isTimeQuantity =
        serviceItem.TimeLimitEnable;
      let quantityDeduction = dataIn.QuantityDeduction;
      this.nonCourseServiceRecordEditorOptions.serviceHoursAvailable =
        serviceItem.QuantityAvailable + quantityDeduction;

      this.nonCourseServiceRecordEditorOptions.visible = true;
    },
    hideNCServiceRecordEditor() {
      this.nonCourseServiceRecordEditorOptions.serviceItem = null;
      this.nonCourseServiceRecordEditorOptions.visible = false;
    },
    onNCServiceRecordEditorChange(dataOut) {
      let serviceItem = this.nonCourseServiceRecordEditorOptions.serviceItem;

      this.$nextTick(async () => {
        dataOut.WorkflowServiceItemId = serviceItem.Id;
        dataOut.ServiceDate = this.$moment(dataOut.ServiceDate).format(
          "YYYY/MM/DD"
        );
        dataOut.Currency = this.currency;
        dataOut.CostAmountDeduction =
          serviceItem.CostAmountUnit * dataOut.QuantityDeduction;
        dataOut.SaleAmountDeduction =
          serviceItem.SaleAmountUnit * dataOut.QuantityDeduction;
        let result = await this.saveSANonCourseServiceRecordToServer(
          dataOut,
          serviceItem
        );
        if (result) this.hideNCServiceRecordEditor();
      });
    },

    onEditEndDate(dataOut) {
      let dataIn = dataOut;
      this.serviceItemEndDateEditorOptions.dataIn = dataIn;
      this.serviceItemEndDateEditorOptions.visible = true;
    },
    hideServiceItemEndDateEditor() {
      this.serviceItemEndDateEditorOptions.dataIn = null;
      this.serviceItemEndDateEditorOptions.visible = false;
    },
    onServiceItemEndDateEditorChange(dataOut) {
      this.$nextTick(async () => {
        let result = await this.changeSAWorkflowServiceItemStartDateToServer(
          dataOut
        );
        if (result) this.hideServiceItemEndDateEditor();
      });
    },
    onAddCourse(data) {
      if (data.IsVIP) {
        this.courseEditorData = {
          isAdd: true,
          isVIP: true,
          hours: 0,
          maxHours:
            data.QuantityTotal !== -1
              ? data.QuantityAvailable
              : Number.maxValue.int32,
          serviceItemName: data.ServiceItemName,
          termId: 0,
          termName: "",
          courseId: 0,
          courseName: "",
          workflowServiceItemId: data.Id,
          workflowCourseId: 0,
          universityGroup: this.studentInfo.UniversityGroupNumber,
        };

        this.courseEditorVisible = true;
      } else {
        this.selectCourseData = {
          studyAbroadData: {
            workflowServiceItemId: data.Id,
            endDate: this.$moment(data.EndDate).format("YYYY/MM/DD"),
            serviceItemName: data.ServiceItemName,
            quantityTotal: data.QuantityTotal,
            quantityAvailable: data.QuantityAvailable,
          },
          universityCourseData: {
            universityGroupNumber: this.studentInfo.UniversityGroupNumber,
            universityGroupText: this.studentInfo.UniversityGroupText,
            termId: 0,
            selectedCourseIdList: [],
          },
        };
        this.selectCourseDialogVisible = true;
      }
    },
    onCourseEdit(data, row) {
      this.courseEditorData = {
        isAdd: false,
        isVIP: data.IsVIP,
        hours: row.QuantityDeduction,
        maxHours:
          data.QuantityTotal !== -1
            ? data.QuantityAvailable + row.QuantityDeduction
            : Number.maxValue.int32,
        serviceItemName: data.ServiceItemName,
        termId: row.TermId,
        termName: row.TermName,
        courseId: row.CourseId,
        courseName: row.CourseName,
        workflowServiceItemId: data.Id,
        workflowCourseId: row.WorkflowCourseId,
        universityGroup: this.studentInfo.UniversityGroupNumber,
      };

      this.courseEditorVisible = true;
    },
    onCourseRefund(data, row) {
      this.courseRefundData = {
        isVIP: data.IsVIP,
        serviceItemName: data.ServiceItemName,
        termId: row.TermId,
        termName: row.TermName,
        courseId: row.CourseId,
        courseName: row.CourseName,
        hours: row.QuantityDeduction,
        workflowServiceItemId: data.Id,
        workflowCourseId: row.WorkflowCourseId,
        universityGroup: this.studentInfo.UniversityGroupNumber,
      };
      this.courseRefundVisible = true;
    },
    updateCourseServiceItem(workflowServiceItemId, courseServiceRecordList) {
      let serviceItem = this.data.find(
        (item) => item.Id === workflowServiceItemId
      );
      if (!!serviceItem) {
        serviceItem.CourseServiceRecordList = courseServiceRecordList;
        let quantityDeduction = serviceItem.CourseServiceRecordList.sum(
          (item) => item.QuantityDeduction
        );
        serviceItem.QuantityAvailable =
          serviceItem.QuantityTotal - quantityDeduction > 0
            ? serviceItem.QuantityTotal - quantityDeduction
            : 0;
        serviceItem.CostAmountAvailable =
          (serviceItem.CostAmountDiscounted / serviceItem.QuantityTotal) *
          serviceItem.QuantityAvailable;
        serviceItem.SaleAmountAvailable =
          (serviceItem.SaleAmountDiscounted / serviceItem.QuantityTotal) *
          serviceItem.QuantityAvailable;
        if (serviceItem.QuantityTotal !== -1 && !serviceItem.QuantityAvailable)
          serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.Completed;
        else if (serviceItem.QuantityAvailable != serviceItem.QuantityTotal)
          serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.InProgress;
        else serviceItem.Status = this.GLOBAL.enumStudyAbroadStatus.NotStart;

        this.$emit("change");
      }
    },
    onSelectCourseSaveSuccess(value) {
      this.selectCourseDialogVisible = false;

      if (
        !!value &&
        !!value.studyAbroadData &&
        !!value.universityCourseData &&
        !!value.universityCourseData.selectedCourseList
      ) {
        let workflowServiceItemId = value.studyAbroadData.workflowServiceItemId;
        let courseIdList = value.universityCourseData.selectedCourseList.map(
          (i) => i.Id
        );
        this.isLoading = true;
        saveStudyAbroadCourses(workflowServiceItemId, courseIdList).then(
          (result) => {
            if (!!result && result.success) {
              this.$message.success("添加课程成功");
              this.updateCourseServiceItem(workflowServiceItemId, result.data);
            } else {
              this.$message.error(result.message);
            }
            this.isLoading = false;
          }
        );
      }
    },
    onCourseEditorSaveSuccess(dataOut) {
      this.courseEditorVisible = false;
      this.updateCourseServiceItem(
        dataOut.workflowServiceItemId,
        dataOut.courseServiceRecordList
      );
    },
    onCourseEditorClose() {
      this.courseEditorVisible = false;
    },
    onCourseRefundSaveSuccess(dataOut) {
      this.courseRefundVisible = false;
      this.updateCourseServiceItem(
        dataOut.workflowServiceItemId,
        dataOut.courseServiceRecordList
      );
    },
    onCourseRefundClose() {
      this.courseRefundVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceItemList-container {
  margin-bottom: 20px;
}

.serviceItemList-title {
  padding: 18px 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/serviceItem/serviceItemList.vue